import { render, staticRenderFns } from "./SponsorsCampaignForm.vue?vue&type=template&id=a23cb6e4"
import script from "./SponsorsCampaignForm.vue?vue&type=script&lang=js"
export * from "./SponsorsCampaignForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports